export default __webpack_public_path__ + "static/media/pink-circle@2x.58193dd7.png";